<template>
    <v-card class="background-card" v-resize="onResize" v-if="isReady">
        <v-card-title v-if="windowSize.x > 1040" class="font-theme d-flex justify-space-between pa-0" style="border-bottom: 1px solid #BCB9B9;">
            <span style="font-weight: 600; font-size: calc(100% + 1.4vw); margin: 3.2% 0% 3.2% 4.8%; line-height: 45px; font-family: 'Sarabun', 'sans-serif';" class="text-center">
                VENDOR : {{ this.selectedBiz.business_detail.name_eng.toUpperCase() }}
            </span>
            <span style="margin: 3.2% 3.2% 3.2% 0%;">
                <v-btn v-if="permissionBtnEditMode" rounded color="green" class="mr-2 white--text text-center download-report-vendor-btn" @click="goToAddVendor()" height="53" width="193" style="font-weight: 700; font-size: 15px; box-shadow: none;">
                    Add Vendor
                </v-btn>
                <v-btn rounded color="#0B68D6" class="white--text text-center download-report-vendor-btn" @click="goToDownloadReport()" height="53" width="193" style="font-weight: 700; font-size: 15px; box-shadow: none;">
                    Download Report
                </v-btn>
            </span>
        </v-card-title>
        <v-card-title v-else class="font-theme d-flex pa-0" style="border-bottom: 1px solid #BCB9B9;">
            <v-row no-gutters class="font-theme standard-row d-flex justify-space-between" style="padding: 3.8% 3.2% 3.8% 3.2%; line-height: 47px;">
                <v-col cols="11" sm="">
                    <span style="font-weight: 400; font-family: 'Sarabun'; font-size: calc(100% + 1.5vw);">VENDOR : <br>{{ this.selectedBiz.business_detail.name_eng.toUpperCase() }}</span>
                </v-col>
                <v-col cols="1" sm="auto">
                    <v-menu offset-y transition="scroll-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" color="#414040">
                                <v-icon size="30">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="background-color: #414040;">
                            <v-list-item dense @click="goToDownloadReport()">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Dowload Report</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense @click="goToAddVendor()" v-if="permissionBtnEditMode">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Add Vendor</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list> 
                    </v-menu>
                </v-col>
            </v-row>
        </v-card-title>
        <v-row no-gutters class="standard-row d-flex justify-end" style="padding: 2.8% 3.2% 2.8% 3.2%;">
            <v-col cols="12" sm="12" md="6" lg="4">
                <v-text-field dense outlined hide-details color="black" placeholder="ค้นหาขั้นสูง" height="53" class="font-theme search-text-field" v-model="holdKeyword" @input="!holdKeyword? checkRowsAndPageBeforeSearch(holdKeyword): ''" @keyup.enter="checkRowsAndPageBeforeSearch(holdKeyword)">
                    <template v-slot:append>
                        <v-btn color="#0B68D6" class="white--text font-theme search-vendor-btn" @click="checkRowsAndPageBeforeSearch(holdKeyword)">
                            Search
                        </v-btn>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters class="standard-row font-theme" style="padding: 0% 3.2% 3.8% 3.2%;">
            <v-data-table :headers="headers" range :items="myVendor" fixed-header class="elevation-0 data-vendor-table-setting" @click:row="detailVendor($event._id)" style="width: 100%" :options.sync="optionsDataTable" :server-items-length="countVendor" :footer-props="{'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text':'จำนวนแถวต่อหน้า'}" mobile-breakpoint="850" :class="!myVendor.length? 'disable-data-vendor-table-setting': ''">
                <template v-if="myVendor.length < 20" v-slot:body.append="{ isMobile }">
                    <tr v-for="(_, index_tr) in (20 - myVendor.length)" :key="`tr__${index_tr}`" v-show="!isMobile">
                        <td v-for="(_, index_td) in 5" :key="`td__${index_td}`"></td>
                    </tr>
                </template>
                <template slot="no-data">
                    <a class="text-center d-flex justify-center black--text" style="font-size: 16px;">
                        ไม่พบข้อมูล
                    </a>
                </template>
                <template v-slot:[`item.vendor_code`]="{ item }">
                    {{ item.vendor_code || '–' }}
                </template>
                <template v-slot:[`item.title_name`]="{ item }">
                    {{ item.title_name || '–' }}
                </template>
                <template v-slot:[`item.vendor_name_th`]="{ item }">
                    {{ item.vendor_name_th || '–' }}
                </template>
                <template v-slot:[`item.vendor_group_code`]="{ item }">
                    {{ item.vendor_group_code || '–' }}
                </template>
                <template v-slot:[`item.tax_id_vendor`]="{ item }">
                    {{ item.tax_id_vendor || '–' }}
                </template>
                <template v-slot:footer.page-text="items">
                    {{ items.pageStart }} - {{ items.pageStop }} จาก {{ items.itemsLength }} แถว
                </template>
            </v-data-table>
        </v-row>
        <v-card-title class="font-theme d-flex justify-end pa-0" style="border-top: 1px solid #BCB9B9;">
            <span style="font-weight: 400; font-size: 20px; margin: 1.95% 3.2% 1.95% 0%; line-height: 45px;" class="text-center">
                Total : {{ countVendor }}
            </span>
        </v-card-title>
        <VendorDetail />
        <AddVendorDetail />
        <DownloadReportModal />
    </v-card>
</template>

<script>
import { EventBus } from '../EventBus'
import VendorDetail from '../components/VendorDetail.vue'
import DownloadReportModal from '../components/DownloadReportModal.vue'
import AddVendorDetail from '@/components/AddVendorDetail.vue'
    export default {
        components: {
            VendorDetail,
            DownloadReportModal,
            AddVendorDetail
        },
        data: () => ({
            keyword: '',
            myVendor: [],
            isReady: false,
            holdKeyword: '',
            countVendor: 0,
            callApiPending: 0,
            windowSize: { x: 0 },
            trigRowPerPage: false,
            optionsDataTable: { page: 1, itemsPerPage: 20 },
            headers: [
                { text: "Vendor Code"       , value: "vendor_code"       , align: "center", sortable: false, width: '14.3%' },
                { text: "Title Name"        , value: "title_name"        , align: "center", sortable: false, width: '10.8%' },
                { text: "Vendor Name"       , value: "vendor_name_th"    , align: "center", sortable: false, width: '34.2%' },
                { text: "Vendor Group Code" , value: "vendor_group_code" , align: "center", sortable: false, width: '17.4%' },
                { text: "เลขที่ผู้เสียภาษี"       , value: "tax_id_vendor"     , align: "center", sortable: false, width: '23.4%' }
            ]
        }),
        mounted () {
            this.onResize()
            this.getAllItem()
            EventBus.$on('reloadPage', () => {
                window.location.reload();
            });
        },
        beforeDestroy() {
            EventBus.$off('reloadPage')
        },
        computed: {
            selectedBiz() {
                return this.$store.state.confirmSelectedBiz
            },
            raDetail() {
            return this.$store.state.raDetail
            },
            permissionBtnEditMode(){
                return this.$store.state.permissionBtnEditMode
            }
        },
        watch: {
            "optionsDataTable.page"() {
                this.getAllItem()
                this.trigRowPerPage = true
            },
            "optionsDataTable.itemsPerPage"() {
                if (!this.trigRowPerPage) {
                    this.optionsDataTable.page = 1
                    this.getAllItem()
                }
            },
            "callApiPending"(val) {
                if (val > 0) {
                    EventBus.$emit('loadingState', true)
                } else {
                    EventBus.$emit('loadingState', false)
                }
            }
        },
        methods: {
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            checkRowsAndPageBeforeSearch(params) {
                if (this.keyword === params) {
                    return
                }
                this.keyword = params.trim()
                if (this.optionsDataTable.page === 1) {
                    this.getAllItem()
                } else {
                    this.optionsDataTable.page = 1
                }
            },
            async detailVendor(id) {
                if (!id) {
                    this.alert('ไม่พบข้อมูล', 'Fail', 'error')
                    return
                } 
                try {
                    this.callApiPending++
                    let {data} = await this.axios.get(`${this.$api_url}/vendor_erp/api/v1/get_vendor?id=${id}`)
                    if(data.status) {
                        for (const keys in data.data) {
                            if (!data.data[keys]) {
                                data.data[keys] = '–'
                            }
                        }
                        EventBus.$emit('openDetailVendor', data.data,id)
                    }
                } catch (error) {
                    console.log(error)
                    this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
                } finally {
                    this.callApiPending--
                }
            },
            goToDownloadReport(){
                const aboutReport = {
                    url  : '/report/api/v1/export_reportvendor',
                    from : 'add_vendor'
                }
                EventBus.$emit('openDownloadReportModal', aboutReport)
            },
            async getAllItem() {
                this.callApiPending++
                const countTransactions = {
                    baseURL : this.$api_url,
                    url     : `/vendor_erp/api/v1/count_all_vendor?tax_id=${this.selectedBiz.tax_id}&keyword=${this.keyword || ''}`,
                    method  : 'GET'
                }
                const searchTransactions = {
                    baseURL : this.$api_url,
                    url     : `/vendor_erp/api/v1/get_all_vendor?tax_id=${this.selectedBiz.tax_id}&keyword=${this.keyword || ''}&offset=${(this.optionsDataTable.page - 1) * this.optionsDataTable.itemsPerPage || 0}&limit=${this.optionsDataTable.itemsPerPage}`,
                    method  : 'GET'
                }
                await Promise.all([ this.axios(countTransactions), this.axios(searchTransactions) ]).then(values => {
                    this.countVendor = values[0].data.data
                    this.myVendor    = values[1].data.data
                    $(".data-vendor-table-setting.v-data-table > .v-data-table__wrapper").scrollTop(0)
                }).catch(error => {
                    this.myVendor = []
                    this.countVendor = 0
                    this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
                    console.log(error)
                }).finally(() => {
                    this.isReady = true
                    this.callApiPending--
                    this.trigRowPerPage = false
                })
            },
            goToAddVendor(){
                EventBus.$emit('openAddVendorDetail')
            },
            alert(title = '', text = 'Fail', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                })
            }
        }
    }
</script>

<style>
    .background-card {
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
        margin: 60px 4.51% 56px 4.51% !important;
        border-radius: 23px !important;
    }

    .search-vendor-btn {
        font-size: 15px;
        font-weight: 700;
        border: 1px solid #000000 !important;
        box-shadow: none;
    }

    .search-vendor-btn.v-btn:not(.v-btn--round).v-size--default {
        height: 53px !important;
        width: 108px;
        border-radius: 0px 15px 15px 0px;
    }

    .search-text-field .v-input__control .v-input__slot {
        padding-right: 0px !important;
    }

    .search-text-field {
        font-size: 15px;
        border-radius: 15px;
    }

    .search-text-field.v-text-field--outlined fieldset {
        border-color: black !important;
    }

    .data-vendor-table-setting thead th {
        height: 49px !important;
        background-color: #333333 !important;
        color: #FFFFFF !important;
        font-size: 20px;
    }

    .data-vendor-table-setting thead th:first-child {
        border-radius: 10px 0 0 0;
    }

    .data-vendor-table-setting thead th:last-child {
        border-radius: 0 10px 0 0;
    }

    .data-vendor-table-setting thead th {
        font-size: 20px !important;
        font-weight: 400;
    }

    .data-vendor-table-setting.v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th {
        position: sticky;
        top: 0;
        z-index: 2;
    }

    .data-vendor-table-setting .v-data-table__wrapper table tbody tr td {
        padding-top: 0px;
        height: 49px !important;
    }

    .disable-data-vendor-table-setting tr {
        pointer-events: none;
    }

    .data-vendor-table-setting tbody tr td {
        border-left: 1px solid #D8D5D5 !important;
        border-right: 1px solid #D8D5D5 !important;
        border-bottom: 0px !important;
    }

    .data-vendor-table-setting tbody tr td:first-child {
        border-left: 0px !important;
        border-right: 1px solid #D8D5D5 !important;
        border-bottom: 0px !important;
    }

    .data-vendor-table-setting tbody tr td:last-child {
        border-left: 1px solid #D8D5D5 !important;
        border-right: 0px !important;
        border-bottom: 0px !important;
    }

    .data-vendor-table-setting tbody tr:nth-of-type(even) {
        background: #F8F5F5;
    }

    .search-text-field .v-input__control .v-input__slot .v-text-field__slot input {
        line-height: 30px;
    }

    .data-vendor-table-setting .v-data-table__wrapper table tbody tr td {
        border-left: none !important;
    }

    .data-vendor-table-setting.v-data-table > .v-data-table__wrapper {
        height: calc(100vh - 174px);
        overflow: auto;
        scroll-behavior: smooth;
    }

    .data-vendor-table-setting.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover {
        cursor: pointer;
    }

    .data-vendor-table-setting.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .data-vendor-table-setting.v-data-table > .v-data-table__wrapper::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: transparent !important;
    }

    .data-vendor-table-setting.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #F8F5F5;
    }

    .download-report-vendor-btn {
        font-weight: 700;
        font-size: 15px;
        border: none !important;
        border-radius: 20px;
    }

    @media only screen and (max-width: 849px) {

        .data-vendor-table-setting tbody tr td:first-child {
            border-top: 1px solid #D8D5D5 !important;
            border-left: 1px solid #D8D5D5 !important;
        }

        .data-vendor-table-setting tbody tr td:last-child {
            border-right: 1px solid #D8D5D5 !important;
            border-bottom: 1px solid #D8D5D5 !important;
        }

        .data-vendor-table-setting .v-data-table__wrapper table tbody .v-data-table__empty-wrapper td {
            width: 100vw;
            border-right: none !important;
            border-bottom: none !important;
        }
    }
</style>